import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ae04636"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "completion1-selected-room"
}
const _hoisted_2 = { class: "completion1-product-reference no-mb" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "completion1-product-info" }
const _hoisted_5 = { class: "completion1-product-price-info" }
const _hoisted_6 = { class: "completion1-product-price no-mb" }
const _hoisted_7 = { class: "completion1-product-vat-rate" }
const _hoisted_8 = { class: "completion1-product-additional-info" }

import { WarningOutlined, CheckOutlined, ZoomInOutlined } from '@ant-design/icons-vue'
import { completion1Store } from '@/stores/v2/completion1'

export default /*#__PURE__*/_defineComponent({
  __name: 'WoononCompletionOneProductsDesktop',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!

  return (_openBlock(), _createBlock(_component_a_tabs, {
    class: "completion1-tabs",
    "tab-position": "left"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(completion1Store)().roomGroups, (roomGroup) => {
        return (_openBlock(), _createBlock(_component_a_tab_pane, {
          key: roomGroup.level + '-' + roomGroup.position
        }, {
          tab: _withCtx(() => [
            _createTextVNode(_toDisplayString(roomGroup.level) + "." + _toDisplayString(roomGroup.position) + " - " + _toDisplayString(roomGroup.roomType.name) + " ", 1),
            (roomGroup.selectedRoom)
              ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                  _createVNode(_unref(CheckOutlined), { style: {"color":"green"} }),
                  _createTextVNode(" " + _toDisplayString(roomGroup.selectedRoom.name), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_a_row, {
              gutter: [16,16],
              class: "no-mb"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_row, {
                      gutter: [16,16],
                      class: "no-mb"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roomGroup.rooms, (room) => {
                          return (_openBlock(), _createBlock(_component_a_col, {
                            span: 24,
                            key: room.id
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_card, { size: "small" }, {
                                title: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(room.name) + " ", 1),
                                  _createElementVNode("p", _hoisted_2, _toDisplayString(room.reference), 1)
                                ]),
                                extra: _withCtx(() => [
                                  (!room.selected)
                                    ? (_openBlock(), _createBlock(_component_a_button, {
                                        key: 0,
                                        loading: _unref(completion1Store)().savingRoomId === room.id,
                                        disabled: _unref(completion1Store)().saving || _unref(completion1Store)().phaseClosed,
                                        onClick: ($event: any) => (_unref(completion1Store)().toggleProduct(room.id))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_unref(completion1Store)().phaseClosed ? 'Niet gekozen' : 'Kies'), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["loading", "disabled", "onClick"]))
                                    : _createCommentVNode("", true),
                                  (room.selected)
                                    ? (_openBlock(), _createBlock(_component_a_button, {
                                        key: 1,
                                        type: "primary"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Gekozen")
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_a_row, {
                                    class: "no-mb",
                                    gutter: [16,16]
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_col, { span: 4 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_image, {
                                            src: room.floorplan?.url || '/img/No_Image.png',
                                            width: "100%"
                                          }, {
                                            previewMask: _withCtx(() => [
                                              _createVNode(_unref(ZoomInOutlined))
                                            ]),
                                            _: 2
                                          }, 1032, ["src"])
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_a_col, { span: 16 }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", {
                                            class: "completion1-commercial-description",
                                            innerHTML: room.description || 'Geen omschrijving beschikbaar.'
                                          }, null, 8, _hoisted_3)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_a_col, { span: 4 }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_4, [
                                            _createElementVNode("div", _hoisted_5, [
                                              _createElementVNode("p", _hoisted_6, _toDisplayString(room.customer_price_text), 1),
                                              _createElementVNode("p", _hoisted_7, "incl. " + _toDisplayString(room.vat_rate_text) + " BTW", 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_8, [
                                              (room.is_excluded_from_warranty)
                                                ? (_openBlock(), _createBlock(_component_a_tooltip, {
                                                    key: 0,
                                                    placement: "right"
                                                  }, {
                                                    title: _withCtx(() => [
                                                      _createTextVNode("Let op! Deze indeling is uitgesloten van de toepasselijke Woningborg Garantie- en waarborgregeling.")
                                                    ]),
                                                    default: _withCtx(() => [
                                                      _createVNode(_unref(WarningOutlined), { style: {"color":"#f38929"} })
                                                    ]),
                                                    _: 1
                                                  }))
                                                : _createCommentVNode("", true),
                                              (room.is_default)
                                                ? (_openBlock(), _createBlock(_component_a_tag, {
                                                    key: 1,
                                                    color: "#f38929",
                                                    style: {"margin-left":"8px","margin-right":"0"}
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode("Standaard")
                                                    ]),
                                                    _: 1
                                                  }))
                                                : _createCommentVNode("", true)
                                            ])
                                          ])
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _: 1
  }))
}
}

})